import React from 'react';
import styled from '@emotion/styled';
import { routes } from 'gatsby-theme-apollo';
import { EntityThumbnailLink } from './entity-list';

const StyledRecommendations = styled.div`
  padding: 10px;
  margin: 0px auto;
  display: flex;
  flex-direction: column;
  width: 80%;
  border-radius: ${props => props.theme.radius};
  justify-content: center;
  align-items: center;
`;

const RecommendationTitle = styled.h3`
  width: 100%;
  text-align: center;
  padding: 5px;
`;

const RecommendationEntitySet = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  flex-shrink: 1;
  flex: 1;
  padding: 5px;
`;

const Recommendations = ({ gameName, recommendations, EntityConfigs }) => {
  const recommendationTypes = [];

  recommendations.forEach(recommendation => {
    const prevFoundRecommendationType = recommendationTypes.find(foundRecoType => {
      return foundRecoType.recotype === recommendation.recotype;
    });

    if (!prevFoundRecommendationType) {
      recommendationTypes.push({
        recotype: recommendation.recotype,
        entities: [recommendation.character]
      });
    } else {
      prevFoundRecommendationType.entities.push(recommendation.character);
    }
  });

  return (
    <StyledRecommendations>
      {recommendationTypes.map(recommendation => {
        return (
          <>
            <RecommendationTitle>{recommendation.recotype}</RecommendationTitle>
            <RecommendationEntitySet>
              {recommendation &&
                recommendation.entities.map(entity => {
                  const thisCharacterEntityType = EntityConfigs.find(entityType => {
                    return entityType.singular === entity.entityType;
                  });

                  return (
                    thisCharacterEntityType &&
                    thisCharacterEntityType.plural && (
                      <EntityThumbnailLink
                        to={routes.Entity(gameName, thisCharacterEntityType.plural, entity.name)}
                        name={entity.name}
                        thumbnailURI={entity.thumbnailURI}
                      />
                    )
                  );
                })}
            </RecommendationEntitySet>
          </>
        );
      })}
    </StyledRecommendations>
  );
};

export default Recommendations;
